import { render, staticRenderFns } from "./CompetitorsReport.vue?vue&type=template&id=ecc3d4c2&"
import script from "./CompetitorsReport.vue?vue&type=script&lang=ts&"
export * from "./CompetitorsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports